export default __webpack_public_path__ + "static/media/Zasway-PassengerApp-Logo.23647f91.png";